import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { IonButton, IonRow } from '@ionic/angular/standalone';
import { SlipComponentHeaderComponent } from '../slip-component-header/slip-component-header.component';
import { SlipComponentInfo } from '../student-slip-item-choices-modal/student-slip-item-choices-modal.store';
import { StudentSlipItemChoicesPaymentComponent } from '../student-slip-item-choices-payment/student-slip-item-choices-payment.component';
import { ItemChoicesComponentInfo, PaymentProgress, PaymentStatus, SlipInfo } from '../student-slip-modal.store';

@Component({
  selector: 'app-student-slip-item-choices',
  templateUrl: './student-slip-item-choices.component.html',
  styleUrls: ['./student-slip-item-choices.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IonButton, SlipComponentHeaderComponent, StudentSlipItemChoicesPaymentComponent, IonRow] })
export class StudentSlipItemChoicesComponent {
  @Input() model: ItemChoicesComponentInfo;
  @Input() paymentStatus: PaymentStatus;
  @Input() slipInfo: SlipInfo;
  @Input() progress: PaymentProgress;
  @Output() paymentMethodUpdated = new EventEmitter<string>();
  @Output() paymentStatusChange = new EventEmitter<PaymentStatus>();
  @Output() viewItemChoices = new EventEmitter<void>();
  @Output() editItemChoices = new EventEmitter<void>();
  constructor() {}

  get buttonInfo(): { legend: string; op: EventEmitter<void> } {
    switch (this.model.status) {
      case 'pending':
        return { legend: 'View and Respond', op: this.editItemChoices };
      case 'done':
        return { legend: 'View Responses', op: this.viewItemChoices };
      case 'restricted':
        return { legend: 'Preview', op: this.viewItemChoices };
      case 'void':
        return { legend: 'View Questions', op: this.viewItemChoices };
      case 'expired':
        return { legend: 'View Questions', op: this.viewItemChoices };
    }
  }

  get hasPayment(): boolean {
    return !!this.model.choices?.find(c => c.unitCost && c.unitCost > 0);
  }

  get slipComponentInfo(): SlipComponentInfo {
    return { ...this.slipInfo, componentId: this.model.componentId };
  }
}
